import { useState } from 'react'
import { useForm } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import { fdeProjectPath, fdeRoutes } from '@/frontend/features/Fde/routes'
import type { ObjectiveCopy, ObjectiveProps } from '@/frontend/features/ProjectObjectives/types'

export default function TaskLinker({ projectId, objectiveId, options, copy: c }: { projectId: string; objectiveId: string; options: ObjectiveProps['objective_task_options']; copy: ObjectiveCopy }) {
  const [open, setOpen] = useState(false)
  const [selected, setSelected] = useState('')
  const form = useForm({ project_task: { project_objective_id: objectiveId, lock_version: 0 } })
  const task = options.find(item => item.id === selected)
  if (!open) return <Button variant="ghost" size="sm" onClick={() => setOpen(true)}>{c.link_task}</Button>
  return <form className="flex max-w-md flex-wrap items-center gap-2" onSubmit={event => {
    event.preventDefault()
    if (!task) return
    form.transform(() => ({ project_task: { project_objective_id: objectiveId, lock_version: task.lock_version } }))
    form.patch(fdeProjectPath(`${fdeRoutes.projectTasks}/${task.id}`, projectId, { return_to: 'objective' }), { preserveScroll: true, onSuccess: () => { setOpen(false); setSelected('') } })
  }}>
    <select aria-label={c.choose_task} className="h-9 min-w-0 flex-1 rounded-md border border-input bg-background px-2 text-xs" value={selected} onChange={event => setSelected(event.target.value)}>
      <option value="">{options.length ? c.choose_task : c.no_available_tasks}</option>
      {options.map(item => <option key={item.id} value={item.id}>{item.identifier} · {item.title}</option>)}
    </select>
    <Button size="sm" disabled={!task || form.processing}>{c.link}</Button>
    <Button type="button" variant="ghost" size="sm" onClick={() => setOpen(false)}>{c.cancel}</Button>
  </form>
}
